import React from 'react';
import { Input as ChakraInput, InputProps as ChakraInputProps } from '@chakra-ui/react';
import { INPUT_VARIANTS } from 'src/theme/theme';

export function Input(props: Omit<ChakraInputProps, 'variant'> & { variant?: INPUT_VARIANTS }) {
  return <ChakraInput {...props} />;
}
